import AccordionText from "@/components/AccordionTextRefresh";
import AccordionTextItem from "@/components/AccordionTextRefresh/AccordionTextItemRefresh";
import { staticOfacRestriction } from "@/components/CourseContent/ContentRefresh/OFACmessage/constants";
import { ProcessedCourse } from "@/common/course/types";
import { parseFAQs } from "@/utils/functions/parseFAQs";
import parse from "html-react-parser";
import useTranslations from "@/i18n/useTranslations";

export interface Props {
  course?: ProcessedCourse;
  variant?: "default" | "pathway";
}
const OFACText: string = `
<p><strong>${staticOfacRestriction.forType("course").trigger}</strong></p>
<p> ${staticOfacRestriction.forType("course").description}</p>`;

export default function FAQs({ course, variant = "default" }: Props) {
  const t = useTranslations("Course");
  const { frequentlyAskedQuestions, hasOfacRestrictions } = course ?? {};
  if (!course?.frequentlyAskedQuestions) return;

  const parsedFaqs = parseFAQs(frequentlyAskedQuestions || "");
  // If parseFAQs returns empty array, fall back to raw HTML
  const faqItems =
    Array.isArray(parsedFaqs) && parsedFaqs.length === 0
      ? (frequentlyAskedQuestions ?? "")
      : parsedFaqs;

  let transformedFaqItems: React.ReactNode[] | string = [];

  if (Array.isArray(faqItems)) {
    // Standard parsed FAQ items
    transformedFaqItems = faqItems.map((item) => (
      <AccordionTextItem key={item.question} trigger={item.question || ""}>
        <p className="mb-0">{item.answer}</p>
      </AccordionTextItem>
    ));
  } else if (variant === "pathway") {
    // Force Pathway styling to parsed FAQ items
    transformedFaqItems = [
      <AccordionTextItem
        key="faq-content"
        trigger={t("frequentlyAskedQuestions")}
      >
        <div className="prose" style={{ wordBreak: "keep-all" }}>
          {parse(faqItems || "")}
        </div>
      </AccordionTextItem>,
    ];
  } else {
    // Default: show as raw HTML
    transformedFaqItems = faqItems;
  }

  if (hasOfacRestrictions) {
    if (Array.isArray(transformedFaqItems)) {
      transformedFaqItems.unshift(
        <AccordionTextItem
          trigger={staticOfacRestriction.forType("course").trigger}
        >
          <p>{staticOfacRestriction.forType("course").description} </p>
        </AccordionTextItem>,
      );
    } else {
      transformedFaqItems = `${transformedFaqItems} ${OFACText}`;
    }
  }

  if (transformedFaqItems?.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-6">
        <h2 className="my-0 md:text-3xl">{t("frequentlyAskedQuestions")}</h2>
        {Array.isArray(transformedFaqItems) ? (
          <AccordionText variant={variant}>{transformedFaqItems}</AccordionText>
        ) : typeof transformedFaqItems === "string" ? (
          <div className="prose" style={{ wordBreak: "keep-all" }}>
            {parse(transformedFaqItems)}
          </div>
        ) : null}
      </div>
    </div>
  );
}
